const rewardsBanner = document.querySelector('.rewards-signup');
if (rewardsBanner) {
	function removeSignup() {
		const closeButton = rewardsBanner.querySelector('.close');
		closeButton.addEventListener('click', () => {
			rewardsBanner.remove();
		})
		
	}
	removeSignup();
}